export function singleton<T>(factory: () => T): () => T {
  let instance: T | undefined = undefined;

  return () => {
    instance ??= factory();

    return instance;
  };
}
